/* eslint-disable radix */
/* eslint-disable camelcase */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { detailServiceURI, serviceURI } from 'src/api';
import apiClient from 'src/api/api-client';
import { setValue } from './MessageSlice';
import { setDefaultValue } from './ServiceItemSlice';

// First, create the thunk
export const fetchServices = createAsyncThunk(
  'service/fetchServices',
  async (params, { rejectWithValue, dispatch }) => {
    try {
      const response = await apiClient
        .handleRequest({
          method: 'get',
          url: `${serviceURI}`,
          params: { ...params, get_all: true },
        })
        .then(res => res.data);
      return response.data;
    } catch (err) {
      dispatch(setValue({ show: true, body: err.message }));
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  },
);

export const detailService = createAsyncThunk(
  'service/detailService',
  async (id, { rejectWithValue, dispatch, getState }) => {
    try {
      const response = await apiClient.handleRequest({
        method: 'get',
        url: `${detailServiceURI(id)}`,
      });
      dispatch(
        setDefaultValue({
          ...response.data.data,
        }),
      );
      return true;
    } catch (err) {
      dispatch(setValue({ show: true, body: err.message }));
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  },
);

export const upsertService = createAsyncThunk(
  'service/upsertService',
  async (data, { rejectWithValue, dispatch, getState }) => {
    try {
      await apiClient.handleRequest({
        method: data.id ? 'put' : 'post',
        url: `${detailServiceURI(data.id)}`,
        data: data.data,
      });
      if (data.id) {
        dispatch(setValue({ show: true, body: 'Cập nhật thành công', color: 'success' }));
      } else {
        dispatch(setValue({ show: true, body: 'Tạo mới thành công', color: 'success' }));
      }

      return true;
    } catch (err) {
      dispatch(setValue({ show: true, body: err.message }));
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  },
);

export const deleteService = createAsyncThunk(
  'service/deleteService',
  async (data, { rejectWithValue, dispatch, getState }) => {
    try {
      await apiClient
        .handleRequest({
          method: 'delete',
          url: `${detailServiceURI(data.id)}`,
        })
        .then(res => res.data);
      dispatch(fetchServices({ page: 1 }));
      return true;
    } catch (err) {
      dispatch(setValue({ show: true, body: err.message }));
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  },
);

// Then, handle actions in your reducers:
const serviceSlice = createSlice({
  name: 'service',
  initialState: {
    entities: [],
    loading: 'idle',
    saving: 'idle',
    saving_id: 0,
    currentRequestId: undefined,
    error: null,
    currentPage: 1,
    totalPage: 1,
    total: 0,
  },
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
  },
  extraReducers: {
    [fetchServices.pending]: (state, action) => {
      if (state.loading === 'idle') {
        state.loading = 'pending';
        state.currentRequestId = action.meta.requestId;
      }
    },
    // Add reducers for additional action types here, and handle loading state as needed
    [fetchServices.fulfilled]: (state, action) => {
      const { requestId } = action.meta;
      if (state.loading === 'pending' && state.currentRequestId === requestId) {
        const { data, last_page, current_page, total } = action.payload;
        state.loading = 'idle';
        state.entities = data;
        state.currentPage = current_page;
        state.totalPage = last_page;
        state.currentRequestId = undefined;
        state.total = total;
      }
    },
    [fetchServices.rejected]: (state, action) => {
      const { requestId } = action.meta;
      if (state.loading === 'pending' && state.currentRequestId === requestId) {
        state.loading = 'idle';
        state.error = action.error;
        state.currentRequestId = undefined;
      }
    },
    [upsertService.pending]: (state, action) => {
      if (state.saving === 'idle') {
        state.saving = 'pending';
        state.currentRequestId = action.meta.requestId;
      }
    },
    [upsertService.fulfilled]: (state, action) => {
      state.saving = 'idle';
    },
    [upsertService.rejected]: (state, action) => {
      const { requestId } = action.meta;
      if (state.saving === 'pending' && state.currentRequestId === requestId) {
        state.saving = 'idle';
        state.error = action.error;
        state.currentRequestId = undefined;
      }
    },
  },
});

export default serviceSlice.reducer;
